import React, { useEffect, useMemo, useState } from 'react';
import { useTable, usePagination } from 'react-table';
import { CARS } from '../../constants/columns';
import { useOutletContext, useParams } from 'react-router-dom';
import { RiErrorWarningLine } from 'react-icons/ri';
import styles from './deal.module.css';

import addItemsToDeal from '../../api/deals/addItemsToDeal';
import getDealCard from '../../api/deals/getDealCard';
import getDealCars from '../../api/deals/getDealCars';
import getCreditAppeal from '../../api/deals/getCreditAppeal';
import ReassignCarButton from '../../components/CreditApplications/ReassignCarButton';
import { DEAL_STATUS_TTL_EXPIRED } from '../../constants/dealStatuses';
import formatNumber from '../../utils/formatNumber';
import {
  BANK_CREDIT_ACCEPTED,
  BANK_CREDIT_REGISTERED,
  BANK_CREDIT_REJECTED,
  BANK_CREDIT_STATUSES,
  BANK_CREDIT_WAITING,
} from '../../constants/bankCreditStatuses';
import Button from '../../components/Button/Button';
import initialFeeCreditCardPayment from '../../api/deals/initialFeeCreditCardPayment';
import Alert from '../../components/Alert/Alert';
import extractErrorMessage from '../../utils/extractErrorMessage';
import {
  BANKS,
  isSapaConveyor,
  DEAL_STEPS,
  DOCUMENT_TYPES_INVOICE,
  INSURANCE_SERVICE_ID_2_5,
  INSURANCE_SERVICE_ID_3,
  INSURANCE_SERVICE_ID_3_5,
} from '../../constants';
import generateCheck from '../../api/deals/generateCheck';
import selectCreditAppeal from '../../api/creditPlatform/selectCreditAppeal';
import getDealDocuments from '../../api/deals/getDealDocuments';
import CommissionPhotos from './DealCreate/FreedomFlow/CommissionPhotos';
import { stepAfterBankSelect } from './DealCreate/bankFirstStep';
import alert from '../../helpers/alert';
import LoaderInline from '../../components/Loader/LoaderInline';
import RoadAssistanceBadge from '../../components/CreditApplications/RoadAssistanceBadge';
import cancelCreditAppeal from '../../api/creditPlatform/forte/cancelCreditAppeal';
import CheckBankStatus from './DealCreate/CommonBankSteps/CheckBankStatus';
import DealConfigureSteps from './DealConfigureSteps';
import removeItemsToDeal from '../../api/deals/removeItemsToDeal';
import CancelCreditFunding from '../../components/CancelCreditFunding';
import ProcessDocumentButton from '../../components/ProcessDocumentButton/ProcessDocumentButton';
import processDocument from '../../api/bank/processDocument';
import UpdateCreditAppeal from './UpdateCreditAppeal';
import StepControlButtons from './DealCreate/CommonBankSteps/StepControlButtons';
import { useOnboarding } from '../../components/Onboarding/onboardingContext';
import { bankErrorSummary, shouldShowBankStatus } from '../../utils/appealSubmitState';
import MyCarUpdateApplication, { needsMyCarUpdate, awaitingMyCarRework, isMyCarConditionCase } from './DealCreate/MyCarFlow/MyCarUpdateApplication';

const columns = CARS;

// ÐÐ½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ð¾Ð½Ð½ÑÐ¹ ÑÑÐ°ÑÑÑ Ð±Ð°Ð½ÐºÐ° Ð»ÐµÐ¶Ð¸Ñ Ð² json Ð·Ð°ÑÐ²ÐºÐ¸: errorMessage Ð·Ð°Ð½ÑÑ ÑÐµÑÐµÐ½Ð¸ÑÐ¼Ð¸
// Ð¸ ÐµÐ³Ð¾ Ð¸Ð·Ð¼ÐµÐ½ÐµÐ½Ð¸Ðµ ÑÐ°ÑÑÑÐ»Ð°ÐµÑ ÐºÐ»Ð¸ÐµÐ½ÑÑ push-ÑÐ²ÐµÐ´Ð¾Ð¼Ð»ÐµÐ½Ð¸Ðµ.
const bankStatusName = (appeal) => {
  try {
    return JSON.parse(appeal?.json || '{}')?.bank_status_name || null;
  } catch (e) {
    return null;
  }
};

const getMock = (appeal) => ({
  ...appeal,
  statusId: BANK_CREDIT_ACCEPTED,
  bank: {
    id: BANKS.TEST,
    name: 'Test Bank',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/3/3f/Placeholder_view_vector.svg',
    body: '',
    api: 'http://localhost:8003',
  },
});

const PrintStyles = () => (
  <style>
    {`
      #printableArea {
        display: none;
      }
      @media print {
        body {
          visibility: hidden;
        }

        #sidebar {
          display: none;
        }
        #DealCreateForm {
          position: static;
        }

        #printableArea {
          display: block;
          visibility: visible;
          position: absolute;
          left: 0;
          top: 0;
        }
        #printableArea button {
          display: none;
        }
      }
    `}
  </style>
);

const DealCredits = ({ dealId, deal: data, onSubmit, documents, backHandler, services, orders, update }) => {
  const context = useParams();
  const id = context?.id || dealId;
  const [cars, setCars] = useState([]);
  // ÐÐ¾ÐºÐ° Ð¼Ð°ÑÐ¸Ð½Ñ Ð½Ðµ Ð¿ÑÐ¸ÐµÑÐ°Ð»Ð¸, Ð½ÐµÐ»ÑÐ·Ñ ÑÐµÑÐ¸ÑÑ, Ð½ÑÐ¶ÐµÐ½ Ð»Ð¸ ÑÑÑÑÑÑÐ¾ÑÐ¾Ð½Ð½Ð¸Ð¹ Ð´Ð¾Ð³Ð¾Ð²Ð¾Ñ:
  // Ð¿Ð¾ Ð¿ÑÑÑÐ¾Ð¼Ñ ÑÐ¿Ð¸ÑÐºÑ ÑÑÑÐµÐ»ÐºÐ° Â«âÂ» ÑÐ²ÐµÐ»Ð° Ð±Ñ Ð¿Ð¾ÑÑÑÐµÐ½Ð¸Ðµ Ð¼Ð¸Ð¼Ð¾ ÑÐ°Ð³Ð°.
  const [carsLoaded, setCarsLoaded] = useState(false);
  let [equipmentsCount, updateCounters, deal] = useOutletContext() || [];
  deal = deal || data;
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingPage, setLoadingPage] = useState(true);
  const [appeals, setAppeals] = useState([]);
  const { completeChecklistItem } = useOnboarding();
  const [succes, setSucces] = useState({});
  const [subsidy, setSubsidy] = useState(null);
  const [chosenBankId, setChosenBankId] = useState(null);
  // ÐÐµÑÐ¶Ð¸Ð¼ ÑÑÐ°ÑÑÑ Ð»Ð¾ÐºÐ°Ð»ÑÐ½Ð¾: init() Ð¿ÐµÑÐµÑÐ¸ÑÑÐ²Ð°ÐµÑ ÐºÐ°ÑÑÐ¾ÑÐºÑ ÑÐ´ÐµÐ»ÐºÐ¸, Ð¿Ð¾ÑÑÐ¾Ð¼Ñ Ð¿Ð¾ÑÐ»Ðµ Ð·Ð°Ð¼ÐµÐ½Ñ
  // Ð¼Ð°ÑÐ¸Ð½Ñ (Ð¾Ð½Ð° ÑÐ½Ð¸Ð¼Ð°ÐµÑ Ð¿ÑÐ¾ÑÑÐ¾ÑÐºÑ) Ð¿Ð»Ð°ÑÐºÐ° Ð¸ ÐºÐ½Ð¾Ð¿ÐºÐ¸ Ð¾Ð±Ð½Ð¾Ð²Ð»ÑÑÑÑÑ Ð±ÐµÐ· Ð¿ÐµÑÐµÐ·Ð°Ð³ÑÑÐ·ÐºÐ¸ ÑÑÑÐ°Ð½Ð¸ÑÑ.
  const [dealStatusId, setDealStatusId] = useState(deal?.statusId ?? deal?.status?.id ?? null);
  const isExpired = dealStatusId === DEAL_STATUS_TTL_EXPIRED;

  // Freedom Ð´Ð»Ñ ÐºÐ¾Ð¼Ð¸ÑÑÐ¸Ð¾Ð½Ð½Ð¾Ð³Ð¾ Ð¸ Ð±/Ñ Ð°Ð²ÑÐ¾ Ð¾ÑÐµÐ½Ð¸Ð²Ð°ÐµÑ Ð·Ð°Ð»Ð¾Ð³ Ð¿Ð¾ ÑÐ¾ÑÐ¾: Ð±ÐµÐ· Ð½Ð¸Ñ /confirm
  // Ð±Ð°Ð½Ðº Ð¾ÑÐºÐ»Ð¾Ð½ÑÐµÑ. Ð¤Ð¾ÑÐ¾ Ð³ÑÑÐ·ÑÑÑÑ Ð´Ð¾ Ð²ÑÐ±Ð¾ÑÐ° Ð¿ÑÐµÐ´Ð»Ð¾Ð¶ÐµÐ½Ð¸Ñ, Ð±ÑÐºÐµÐ½Ð´ Ð¾ÑÐ¿ÑÐ°Ð²Ð»ÑÐµÑ Ð¸Ñ Ð² Ð±Ð°Ð½Ðº
  // Ð¿ÑÐ¸ Ð²ÑÐ±Ð¾ÑÐµ Freedom (POST /api/bank/ffin/car-photo, Ffin.CollectCarPhotoSources).
  const [freedomPhotosReady, setFreedomPhotosReady] = useState(false);
  const isJetFin = (appeal) => (appeal?.bank?.id ?? appeal?.bankId) === BANKS.JETFIN;

  // Jet Finance Ð¿ÑÐ¸ÑÑÐ»Ð°ÐµÑ Ð¾Ð´Ð¾Ð±ÑÐµÐ½Ð¸Ðµ ÑÐ°Ð½ÑÑÐµ ÑÑÐ»Ð¾Ð²Ð¸Ð¹: ÑÐºÐ¾ÑÐ¸Ð½Ð³ Ð¾ÑÐ²ÐµÑÐ°ÐµÑ approved,
  // Ð° ÑÑÐ¼Ð¼Ñ, ÑÑÐ¾Ðº, ÑÑÐ°Ð²ÐºÑ Ð¸ Ð¿Ð»Ð°ÑÑÐ¶ Ð±Ð°Ð½Ðº Ð´Ð°ÑÑ Ð¿Ð¾Ð·Ð¶Ðµ, Ð² offer Ð²ÐµÐ±ÑÑÐºÐ°. ÐÐ¾ÐºÐ° Ð¸Ñ Ð½ÐµÑ,
  // Ð² ÐºÐ°ÑÑÐ¾ÑÐºÐµ Ð¿Ð¾Ð´ÑÑÐ°Ð²Ð»ÑÐ»Ð¸ÑÑ ÐÐÐ¨Ð Ð·Ð°Ð¿ÑÐ¾ÑÐµÐ½Ð½ÑÐµ Ð·Ð½Ð°ÑÐµÐ½Ð¸Ñ (ÑÑÐ°Ð²ÐºÐ° 10 % â Ð²Ð¾Ð¾Ð±ÑÐµ
  // ÑÐ¼Ð¾Ð»ÑÐ°Ð½Ð¸Ðµ Ð¿ÑÐ¸ ÑÐ¾Ð·Ð´Ð°Ð½Ð¸Ð¸ Ð·Ð°ÑÐ²ÐºÐ¸), Ð¸ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ Ð²Ð¸Ð´ÐµÐ» Ð¸Ñ ÐºÐ°Ðº ÑÑÐ»Ð¾Ð²Ð¸Ñ Ð±Ð°Ð½ÐºÐ°.
  const conditionsNotReceived = (appeal) =>
    isJetFin(appeal) && !appeal?.other_conditions?.length && !appeal?.loan_amount;

  // ÐÑÐ²Ð°ÐµÑ, ÑÑÐ¾ Ð±Ð°Ð½Ðº Ð¿ÑÐ¸ÑÐ»Ð°Ð» Ð¾ÑÑÐµÑ, Ð½Ð¾ ÑÑÐ°Ð²ÐºÐ° Ð¸ Ð¿Ð»Ð°ÑÑÐ¶ Ð² Ð½ÑÐ¼ Ð½ÑÐ»Ð¸ (Ð·Ð°ÑÐ²ÐºÐ° 758891).
  // ÐÐµÑÐ°ÑÐ°ÑÑ Â«0 %Â» Ð½ÐµÐ»ÑÐ·Ñ: Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ Ð½Ð°Ð·Ð¾Ð²ÑÑ ÐºÐ»Ð¸ÐµÐ½ÑÑ Ð±ÐµÑÐ¿ÑÐ¾ÑÐµÐ½ÑÐ½ÑÐ¹ ÐºÑÐµÐ´Ð¸Ñ.
  const rateUnknown = (appeal, condition) =>
    isJetFin(appeal) && !Number(condition?.rate ?? appeal?.percent);

  const paymentUnknown = (appeal, condition) =>
    isJetFin(appeal) && !Number(condition?.payment ?? appeal?.monthlyPayment);

  const freedomAppeal = appeals?.find((a) => (a?.bank?.id ?? a?.bankId) === BANKS.FREEDOM);
  const jetfinAppeal = appeals?.find((a) => (a?.bank?.id ?? a?.bankId) === BANKS.JETFIN);
  // Ð¤Ð¾ÑÐ¾ Ð´Ð»Ñ Ð¾ÑÐµÐ½ÐºÐ¸ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ Ð½ÑÐ¶Ð½Ñ Ð¸ Freedom, Ð¸ Jet Finance. ÐÐ°Ð³ÑÑÐ¶Ð°ÑÑÑÑ Ð²
  // Ð¾Ð´Ð½Ð¾ Ð¼ÐµÑÑÐ¾ â Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÑ ÑÐ´ÐµÐ»ÐºÐ¸, Ð° Ð´Ð°Ð»ÑÑÐµ ÐºÐ°Ð¶Ð´ÑÐ¹ Ð±Ð°Ð½Ðº Ð·Ð°Ð±Ð¸ÑÐ°ÐµÑ Ð¸Ñ Ð¿Ð¾-ÑÐ²Ð¾ÐµÐ¼Ñ.
  const carPhotosAppeal = freedomAppeal || jetfinAppeal;
  const commissionCar = (() => {
    try {
      return !!JSON.parse(deal?.creditAppeal?.json || deal?.creditAppel?.json || '{}')?.initialRegistration;
    } catch (e) {
      return false;
    }
  })();
  const requiresCarPhotos = !!(cars?.[0]?.used || commissionCar);
  // ÐÐ¾Ð²Ð°Ñ Ð¼Ð°ÑÐ¸Ð½Ð° Ð¸Ð· ÑÐ°Ð»Ð¾Ð½Ð°: Ð¾ÑÐµÐ½Ð¸Ð²Ð°ÑÑ Ð·Ð°Ð»Ð¾Ð³ Ð½ÐµÑÐµÐ³Ð¾, Ð½Ð¾ Jet Finance Ð¶Ð´ÑÑ ÑÐ½Ð¸Ð¼Ð¾Ðº
  // VIN â Ð±ÐµÐ· Ð½ÐµÐ³Ð¾ Ð·Ð°ÑÐ²ÐºÐ° ÑÑÐ¾Ð¸Ñ Ð² pre_approved (ÑÐ´ÐµÐ»ÐºÐ° 3248, Ð·Ð°ÑÐ²ÐºÐ° 759282).
  // Freedom Ð¿Ð¾ Ð½Ð¾Ð²Ð¾Ð¹ Ð¼Ð°ÑÐ¸Ð½Ðµ ÑÐ¾ÑÐ¾ Ð½Ðµ Ð¿ÑÐ¾ÑÐ¸Ñ, Ð¿Ð¾ÑÑÐ¾Ð¼Ñ Ð±Ð»Ð¾Ðº Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÐµÐ¼ ÑÐ¾Ð»ÑÐºÐ¾
  // Ð¿ÑÐ¸ Ð·Ð°ÑÐ²ÐºÐµ Ð² Jet Finance Ð¸ Ð²ÑÐ±Ð¾Ñ Ð±Ð°Ð½ÐºÐ° Ð¸Ð¼ Ð½Ðµ Ð·Ð°Ð¿Ð¸ÑÐ°ÐµÐ¼.
  const newCarVinPhoto = !requiresCarPhotos && !!jetfinAppeal;

  // Ð§ÐµÐº-Ð»Ð¸ÑÑ Ð½Ð¾Ð²Ð¸ÑÐºÐ°: Ð·Ð°ÑÐ²ÐºÐ° ÑÑÐ¸ÑÐ°ÐµÑÑÑ Ð¿Ð¾Ð´Ð°Ð½Ð½Ð¾Ð¹, ÐºÐ¾Ð³Ð´Ð° Ð² ÑÐ´ÐµÐ»ÐºÐµ Ð¿Ð¾ÑÐ²Ð¸Ð»Ð¸ÑÑ
  // Ð¾Ð±ÑÐ°ÑÐµÐ½Ð¸Ñ Ð² Ð±Ð°Ð½ÐºÐ¸, Ð° ÑÐµÑÐµÐ½Ð¸Ñ â ÐºÐ¾Ð³Ð´Ð° ÑÐ¾ÑÑ Ð±Ñ Ð¿Ð¾ Ð¾Ð´Ð½Ð¾Ð¼Ñ Ð¿ÑÐ¸ÑÐ»Ð¸ ÑÑÐ»Ð¾Ð²Ð¸Ñ.
  useEffect(() => {
    if (!appeals?.length) return;

    completeChecklistItem('application');

    const answered = appeals.some(
      (appeal) => appeal?.selected || appeal?.other_conditions?.length || appeal?.loan_amount,
    );
    if (answered) completeChecklistItem('decisions');
  }, [appeals, completeChecklistItem]);

  useEffect(() => {
    try {
      const newSubsidy = JSON.parse(deal?.creditAppel?.json)?.subsidy;

      setSubsidy(newSubsidy);
    } catch (e) {}
  }, [deal]);

  const fetchAllAppeals = async (chunkId, page = 1, accumulated = []) => {
    const res = await getCreditAppeal({ chunkId, page });
    const allAppeals = [...accumulated, ...res.data?.appeals];
    if (res.data?.pagination?.hasNextPage) {
      return fetchAllAppeals(chunkId, page + 1, allAppeals);
    }
    return allAppeals;
  };

  const init = async () => {
    const { data } = await getDealCard({ id });
    setDealStatusId(data?.statusId ?? data?.status?.id ?? null);

    getDealCars({ id }).then((res) => {
      setCars(res.data?.cars || []);
      setCarsLoaded(true);
    });

    fetchAllAppeals(data?.chunkId)
      .then((appeals) => {
        const chosenBank = appeals?.find((appeal) => appeal?.selected);
        setChosenBankId(chosenBank?.bank?.id);
        setAppeals(appeals);
      })
      .finally(() => setLoadingPage(false));
  };

  React.useEffect(() => {
    init();
  }, []);

  const handeSubmit = async (cars) => {
    setLoading(true);
    try {
      cars = cars.map(({ value }) => ({ value }));

      const { data } = await getDealCard({ id });

      addItemsToDeal({
        dealId: String(id),
        clientId: data?.client?.id,
        cars,
      })
        .then(() => {
          setShowModal(false);
          updateCounters();
          init();
        })
        .catch((err) => alert(err))
        .finally(() => setLoading(false));
    } catch (e) {
      setLoading(false);
    }
  };

  const table = useTable(
    {
      columns,
      data: cars,
      disableSortRemove: true,
    },
    usePagination
  );

  const cardPayment = (appeal) => {
    setLoadingPage(true);
    initialFeeCreditCardPayment({
      bankId: appeal?.bank?.id,
      chunkId: deal?.chunkId,
    })
      .then(() => {
        setSucces({ message: 'Ð¡Ð¼Ñ ÑÐ¾ ÑÑÑÐ»ÐºÐ¾Ð¹ Ð½Ð° Ð¾Ð¿Ð»Ð°ÑÑ Ð¾ÑÐ¿ÑÐ°Ð²Ð»ÐµÐ½Ð¾ Ð½Ð° Ð½Ð¾Ð¼ÐµÑ ÑÐµÐ»ÐµÑÐ¾Ð½Ð° ÐºÐ»Ð¸ÐµÐ½ÑÐ°' });
        onSubmit();
      })
      .catch((err) => {
        if (extractErrorMessage(err?.response?.data) == 'ÐÐ°ÐºÐ°Ð· Ñ ÑÐºÐ°Ð·Ð°Ð½Ð½ÑÐ¼ external_id ÑÐ¶Ðµ ÑÑÑÐµÑÑÐ²ÑÐµÑ') {
          return onSubmit();
        }
        setSucces({ message: extractErrorMessage(err?.response?.data) });
      })
      .finally(() => setLoadingPage(false));
  };
  const getInvoice = (appeal) => {
    getDealDocuments({ id: deal?.id })
      .then((res) => {
        setLoadingPage(true);
        const url = res?.data?.find((item) => item?.typeId === DOCUMENT_TYPES_INVOICE);
        if (url) {
          window.open(url?.url, '_blank');
          onSubmit();
        }
      })
      .finally(() => {
        setLoadingPage(false);
      });
  };

  const removeInsuranceFromDeal = async () => {
    const insuranceServices = services.filter((service) =>
      [INSURANCE_SERVICE_ID_2_5, INSURANCE_SERVICE_ID_3, INSURANCE_SERVICE_ID_3_5].includes(
        service.additionalServicesId
      )
    );

    if (insuranceServices?.length == 0) {
      return;
    }

    for (const service of insuranceServices) {
      await removeItemsToDeal({
        services: [{ value: service.id }],
        dealId: deal?.id,
      });
    }
  };

  const chooseBank = async (appeal, offerType) => {
    if ((appeal?.bank?.id ?? appeal?.bankId) === BANKS.FREEDOM && requiresCarPhotos && !freedomPhotosReady) {
      alert.error(
        'Ð¡Ð½Ð°ÑÐ°Ð»Ð° Ð·Ð°Ð³ÑÑÐ·Ð¸ÑÐµ 5 ÑÐ¾ÑÐ¾ Ð°Ð²ÑÐ¾ (ÑÐ¿ÐµÑÐµÐ´Ð¸, ÑÐ»ÐµÐ²Ð°, ÑÐ¿ÑÐ°Ð²Ð°, ÑÐ·Ð°Ð´Ð¸, VIN) â Ð±Ð»Ð¾Ðº Â«Ð¤Ð¾ÑÐ¾ Ð°Ð²ÑÐ¾ Ð´Ð»Ñ Ð¾ÑÐµÐ½ÐºÐ¸ Ð·Ð°Ð»Ð¾Ð³Ð°Â» Ð²ÑÑÐµ.'
      );
      return;
    }
    try {
      setLoadingPage(true);

      if (appeal?.bank?.id !== BANKS.FORTE) {
        await removeInsuranceFromDeal();
      }

      await selectCreditAppeal({ appealId: appeal?.id, offerType });
      if (appeal?.bank?.id !== BANKS.FORTE) {
        const forteAppeal = appeals.find((appeal) => appeal?.bank?.id === BANKS.FORTE);
        if (forteAppeal) {
          cancelCreditAppeal(forteAppeal?.id);
        }
      }
      await generateCheck({
        bankId: appeal.bankId,
        chunkId: data.chunkId,
      });

      onSubmit(appeal?.bankId, appeal);
    } catch (e) {
      setLoadingPage(false);
      alert.error(e?.response?.data?.message || 'ÐÑÐ¸Ð±ÐºÐ° Ð¿ÑÐ¸ Ð²ÑÐ±Ð¾ÑÐµ Ð±Ð°Ð½ÐºÐ°');
    }
  };

  const updateAppeals = () => {
    setLoadingPage(true);
    init();
  };

  const printForClient = () => {
    window.print();
  };

  // Ð¢Ð¾Ñ Ð¶Ðµ Ð¼Ð°ÑÑÑÑÑ, ÑÑÐ¾ Ð¸ Ñ onBankSelect: ÑÐ²Ð¾Ñ ÐºÐ¾Ð¿Ð¸Ñ ÐºÐ°ÑÑÑ Â«Ð±Ð°Ð½Ðº â ÑÐ°Ð³Â» ÑÐ²Ð¾Ð´Ð¸Ð»Ð°
  // Ð¿Ð¾ÑÑÑÐµÐ½Ð¸Ðµ Ð¼Ð¸Ð¼Ð¾ ÑÑÑÑÑÑÐ¾ÑÐ¾Ð½Ð½ÐµÐ³Ð¾ Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÐ° Ð¸ ÑÐ¶Ðµ ÑÐ°Ð·Ð¾ÑÐ»Ð°ÑÑ Ñ Ð½ÐµÐ¹ Ð¿Ð¾ EURAZ.
  const nextStep = useMemo(() => {
    const chosenAppeal = appeals.find((appeal) => appeal?.selected);
    if (!chosenAppeal?.bankId || !carsLoaded) {
      return null;
    }
    return stepAfterBankSelect(chosenAppeal.bankId, chosenAppeal, cars);
  }, [appeals, cars, carsLoaded]);

  return (
    <>
      <div className={dealId ? '' : styles.credit}>
        {carPhotosAppeal && (requiresCarPhotos || newCarVinPhoto) && (
          <CommissionPhotos
            appealId={carPhotosAppeal?.id}
            documents={documents}
            onReadyChange={setFreedomPhotosReady}
            banks={[freedomAppeal ? BANKS.FREEDOM : null, jetfinAppeal ? BANKS.JETFIN : null].filter(Boolean)}
            newCar={newCarVinPhoto}
          />
        )}
        <div className={styles.credit__main_info}>
          <div className="deal__card-title">
            <h3
              className={styles.title}
              style={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              ÐÑÐ²ÐµÑÑ Ð¾Ñ Ð±Ð°Ð½ÐºÐ¾Ð²
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{
                  marginLeft: 10,
                  cursor: 'pointer',
                }}
                onClick={updateAppeals}
              >
                <path
                  d="M5.463 4.43301C7.27756 2.86067 9.59899 1.99666 12 2.00001C17.523 2.00001 22 6.47701 22 12C22 14.136 21.33 16.116 20.19 17.74L17 12H20C20.0001 10.4316 19.5392 8.89781 18.6747 7.58927C17.8101 6.28072 16.5799 5.25517 15.1372 4.64013C13.6944 4.0251 12.1027 3.84771 10.56 4.13003C9.0172 4.41234 7.59145 5.14191 6.46 6.22801L5.463 4.43301ZM18.537 19.567C16.7224 21.1393 14.401 22.0034 12 22C6.477 22 2 17.523 2 12C2 9.86401 2.67 7.88401 3.81 6.26001L7 12H4C3.99987 13.5684 4.46075 15.1022 5.32534 16.4108C6.18992 17.7193 7.42007 18.7449 8.86282 19.3599C10.3056 19.9749 11.8973 20.1523 13.44 19.87C14.9828 19.5877 16.4085 18.8581 17.54 17.772L18.537 19.567Z"
                  fill="#B45436"
                />
              </svg>
              {nextStep ? (
                <div style={{ marginLeft: 'auto' }}>
                  <StepControlButtons dealId={id} nextStep={nextStep} update={update} setLoading={setLoadingPage} />
                </div>
              ) : null}
              <PrintStyles />
            </h3>
          </div>
          {/* {appeals[0]?.orders?.map((order) => {
                  return (
                    <p style={textStyles.fieldLabel}>
                      {order?.mark?.name} {order?.model?.name} {order?.complectation} / {order?.issueYear}
                    </p>
                  );
                })} */}
          {/* <p style={textStyles.fieldLabel}>Ð¡ÑÐ¾Ð¸Ð¼Ð¾ÑÑÑ, ÑÐµÐ½Ð³Ðµ: {formatNumber(appeals[0]?.fullPrice)}</p>
                <p style={textStyles.fieldLabel}>
                  ÐÐ°Ð¿ÑÐ°ÑÐ¸Ð²Ð°ÐµÐ¼ÑÐ¹ Ð¿ÐµÑÐ²Ð¾Ð½Ð°ÑÐ°Ð»ÑÐ½ÑÐ¹ Ð²Ð·Ð½Ð¾Ñ, ÑÐµÐ½Ð³Ðµ: {formatNumber(appeals[0]?.initialFee)}
                </p>
                <p style={textStyles.fieldLabel}>
                  ÐÐ°Ð¿ÑÐ°ÑÐ¸Ð²Ð°ÐµÐ¼ÑÐ¹ ÑÑÐ¾Ðº ÐºÑÐµÐ´Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ñ: {formatNumber(appeals[0]?.period)} Ð¼.
                </p> */}
        </div>
        {isExpired && (
          <div style={{ background: '#FDEDED', border: '1px solid #EE7171', borderRadius: 8, padding: '10px 16px', margin: '0 20px 16px' }}>
            ÐÐ°Ð½ÐºÐ¸ Ð½Ðµ Ð¾ÑÐ²ÐµÑÐ¸Ð»Ð¸ Ð² ÑÑÐ¾Ðº, Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ ÑÐ½ÑÑ Ñ Ð±ÑÐ¾Ð½Ð¸. ÐÐ¾Ð´Ð±ÐµÑÐ¸ÑÐµ Ð´ÑÑÐ³Ð¾Ð¹ â ÑÐ´ÐµÐ»ÐºÐ° Ð²ÐµÑÐ½ÑÑÑÑ Ð² ÑÐ°Ð±Ð¾ÑÑ.
          </div>
        )}
        {/* ÐÐ°ÑÐ¸Ð½Ð° Ð² ÑÐ´ÐµÐ»ÐºÐµ Ð¾Ð´Ð½Ð° Ð½Ð° Ð²ÑÐµ Ð¾ÑÑÐµÑÑ, Ð¿Ð¾ÑÑÐ¾Ð¼Ñ ÐºÐ½Ð¾Ð¿ÐºÐ° Ð¾Ð±ÑÐ°Ñ â Ð½Ðµ Ð²Ð½ÑÑÑÐ¸ ÐºÐ°ÑÑÐ¾ÑÐºÐ¸ Ð±Ð°Ð½ÐºÐ°. */}
        <div style={{ margin: '0 20px 16px' }}>
          <ReassignCarButton
            orderId={cars?.[0]?.orderId}
            complectationId={cars?.[0]?.complectationId}
            color={cars?.[0]?.color}
            onDone={init}
          />
        </div>
        {loadingPage ? (
          <LoaderInline />
        ) : (
          appeals.map((item) => {
            return (
              <div className={styles.bank}>
                <div className={styles.bank__row}>
                  <div className={styles.bank__img}>
                    <img src={item?.bank?.logo} />
                  </div>
                  <p className={styles.bank_name}>{item?.bank?.name}</p>
                  <p
                    className={`${styles.status} ${item?.statusId == BANK_CREDIT_ACCEPTED && styles.status__accepted} ${
                      item?.statusId == BANK_CREDIT_REJECTED && styles.status__rejected
                    }`}
                  >
                    {BANK_CREDIT_STATUSES[item?.statusId]}
                  </p>
                </div>
                <div style={{ padding: '0 20px' }}>
                  {item?.bank?.id == BANKS.HALYK ? (
                    <p className={styles.sub} style={{ marginBottom: 5 }}>
                      Ð¡ÑÐ±ÑÐ¸Ð´Ð¸Ñ: {subsidy ? 'ÐÐ°' : 'ÐÐµÑ'}
                    </p>
                  ) : null}
                  <p className={styles.sub} style={{ marginBottom: 5 }}>
                    bankUniqueId: {item?.bankUniqueId}
                  </p>
                  <p className={styles.sub} style={{ marginBottom: 5 }}>
                    bankOwnerId: {item?.bankOwnerId}
                  </p>
                </div>
                {item?.errorMessage ? (
                  <div style={{ padding: '0 20px', marginBottom: 20 }}>
                    <p className={styles.sub} style={{ color: '#EE7171', wordBreak: 'break-all' }}>
                      {bankErrorSummary(item?.errorMessage)}
                    </p>
                  </div>
                ) : null}
                {/* Â«ÐÐ´Ð¾Ð±ÑÐµÐ½Ð¾ Ñ Ð´Ð¾ÑÐ°Ð±Ð¾ÑÐºÐ¾Ð¹Â»: Ð±Ð»Ð¾Ðº Ð½ÑÐ¶ÐµÐ½ Ð¸ Ð½Ð° ÑÐ°Ð³Ðµ Â«ÐÐ°Ð½ÐºÂ» Ð²Ð½ÑÑÑÐ¸ ÑÐ´ÐµÐ»ÐºÐ¸,
                    Ð° Ð½Ðµ ÑÐ¾Ð»ÑÐºÐ¾ Ð½Ð° Ð²ÐºÐ»Ð°Ð´ÐºÐµ Â«ÐÐ°Ð½ÐºÐ¸Â» â Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ Ð²Ð¸Ð´Ð¸Ñ ÐºÐ°ÑÑÐ¾ÑÐºÑ Ð·Ð´ÐµÑÑ. */}
                {isMyCarConditionCase(item, BANKS.MYCAR) ? (
                  <div style={{ padding: '0 20px', marginBottom: 20 }}>
                    <p className={styles.sub}>
                      ÐÐ°Ð½Ðº Ð¾Ð´Ð¾Ð±ÑÐ¸Ð» Ð·Ð°ÑÐ²ÐºÑ Ð½Ð° ÑÐ²Ð¾Ð¸Ñ ÑÑÐ»Ð¾Ð²Ð¸ÑÑ â Ð¾Ð½Ð¸ Ð¿Ð¾ÐºÐ°Ð·Ð°Ð½Ñ Ð½Ð¸Ð¶Ðµ. ÐÑÐ»Ð¸ ÐºÐ»Ð¸ÐµÐ½Ñ
                      ÑÐ¾Ð³Ð»Ð°ÑÐµÐ½, Ð½Ð°Ð¶Ð¼Ð¸ÑÐµ Â«ÐÑÐ±ÑÐ°ÑÑ Ð¿ÑÐµÐ´Ð»Ð¾Ð¶ÐµÐ½Ð¸ÐµÂ»: ÑÐ¾Ð³Ð»Ð°ÑÐ¸Ðµ ÑÐ¹Ð´ÑÑ Ð² MyCar.
                    </p>
                  </div>
                ) : null}
                {needsMyCarUpdate(item, BANKS.MYCAR) ? (
                  <div style={{ padding: '0 20px' }}>
                    <MyCarUpdateApplication
                      appealId={item?.id}
                      onSuccess={() => {
                        init();
                        update && update();
                      }}
                    />
                  </div>
                ) : null}
                {/* ÐÐ½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ð¾Ð½Ð½ÑÐ¹ ÑÑÐ°ÑÑÑ Ð±Ð°Ð½ÐºÐ° (Â«ÐÐ¶Ð¸Ð´Ð°ÐµÑ ÑÐ°ÑÑÐ¼Ð¾ÑÑÐµÐ½Ð¸ÑÂ» Ñ Shinhan) â
                    Ð½Ðµ Ð¾ÑÐºÐ°Ð·, Ð¿Ð¾ÑÑÐ¾Ð¼Ñ ÑÐµÑÑÐ¼, Ð° Ð½Ðµ ÐºÑÐ°ÑÐ½ÑÐ¼. ÐÑÐºÐµÐ½Ð´ ÐºÐ»Ð°Ð´ÑÑ ÐµÐ³Ð¾ Ð² json
                    Ð·Ð°ÑÐ²ÐºÐ¸: errorMessage Ð·Ð°Ð½ÑÑ ÑÐµÑÐµÐ½Ð¸ÑÐ¼Ð¸ Ð¸ ÑÐ»ÑÑ ÐºÐ»Ð¸ÐµÐ½ÑÑ push. */}
                {shouldShowBankStatus(item) && bankStatusName(item) ? (
                  <div style={{ padding: '0 20px', marginBottom: 20 }}>
                    <p className={styles.sub}>{bankStatusName(item)}</p>
                  </div>
                ) : null}
                <div
                  style={{
                    padding: '0 20px',
                    gap: 20,
                    marginTop: 20,
                    marginBottom: 20,
                    display: 'flex',
                    justifyContent: 'space-between',
                    flexWrap: 'wrap',
                  }}
                >
                  {item?.bankId != BANKS.SHINHAN ? (
                    <CheckBankStatus
                      bankId={item?.bankId}
                      onSuccess={updateAppeals}
                      chunkId={deal?.chunkId}
                      setLoading={setLoadingPage}
                      // Forte ÑÐµÑÐµÐ½Ð¸Ðµ ÑÐ°Ð¼ Ð½Ðµ Ð¿ÑÐ¸ÑÑÐ»Ð°ÐµÑ â ÐµÐ³Ð¾ Ð½ÑÐ¶Ð½Ð¾ Ð·Ð°Ð¿ÑÐ¾ÑÐ¸ÑÑ.
                      // ÐÐ¾ Ð¾ÑÑÐ°Ð»ÑÐ½ÑÐ¼ Ð±Ð°Ð½ÐºÐ°Ð¼ Ð¾ÑÐ²ÐµÑ Ð¿ÑÐ¸ÑÐ¾Ð´Ð¸Ñ Ð±ÐµÐ· Ð½Ð°ÑÐµÐ³Ð¾ ÑÑÐ°ÑÑÐ¸Ñ,
                      // Ð¸ ÐºÐ½Ð¾Ð¿ÐºÐ° ÑÐ°Ð¼ Ð¿ÑÐ¾ÑÑÐ¾ Ð¾Ð±Ð½Ð¾Ð²Ð»ÑÐµÑ ÐºÐ°ÑÑÐ¾ÑÐºÑ.
                      text={item?.bankId == BANKS.FORTE ? 'ÐÐ¾Ð»ÑÑÐ¸ÑÑ Ð¾ÑÐ²ÐµÑ Forte' : 'ÐÐ±Ð½Ð¾Ð²Ð¸ÑÑ'}
                      hint={
                        item?.bankId == BANKS.FORTE
                          ? 'Forte Ð½Ðµ Ð¿ÑÐ¸ÑÑÐ»Ð°ÐµÑ ÑÐµÑÐµÐ½Ð¸Ðµ ÑÐ°Ð¼. ÐÐ°Ð¶Ð¼Ð¸ÑÐµ, ÑÑÐ¾Ð±Ñ Ð·Ð°Ð¿ÑÐ¾ÑÐ¸ÑÑ Ð¾ÑÐ²ÐµÑ Ð±Ð°Ð½ÐºÐ° â Ð¾Ð´Ð¾Ð±ÑÐµÐ½Ð¸Ðµ Ð¸Ð»Ð¸ Ð¾ÑÐºÐ°Ð· Ð¿ÑÐ¸Ð´ÑÑ Ð² ÐºÐ°ÑÑÐ¾ÑÐºÑ.'
                          : undefined
                      }
                    />
                  ) : null}
                  {item.bankId == BANKS.EURAZ && item?.statusId == BANK_CREDIT_WAITING ? (
                    <div>
                      <ProcessDocumentButton chunkId={deal?.chunkId} />
                    </div>
                  ) : null}
                  {item?.bankId == BANKS.BCK && item?.statusId == BANK_CREDIT_WAITING && (
                    <UpdateCreditAppeal
                      appeal={item}
                      orders={orders}
                      deal={deal}
                      documents={documents}
                      update={update}
                    />
                  )}
                </div>
                {(item?.statusId == BANK_CREDIT_ACCEPTED || item?.statusId == BANK_CREDIT_REGISTERED) && (
                  <>
                    <div>
                      <p className={styles.sub}>
                        {conditionsNotReceived(item)
                          ? 'ÐÐ°Ð½Ðº Ð¿ÑÐµÐ´Ð²Ð°ÑÐ¸ÑÐµÐ»ÑÐ½Ð¾ Ð¾Ð´Ð¾Ð±ÑÐ¸Ð» Ð·Ð°ÑÐ²ÐºÑ. Ð£ÑÐ»Ð¾Ð²Ð¸Ñ ÐµÑÑ Ð½Ðµ Ð¿ÑÐ¸ÑÐ»Ð¸.'
                          : 'ÐÐ»Ð¸ÐµÐ½ÑÑ Ð¾Ð´Ð¾Ð±ÑÐµÐ½ ÐºÑÐµÐ´Ð¸Ñ Ð½Ð° ÑÐ»ÐµÐ´ÑÑÑÐ¸Ñ ÑÑÐ»Ð¾Ð²Ð¸ÑÑ:'}
                      </p>
                      {conditionsNotReceived(item) ? (
                        <div
                          style={{
                            background: '#FFF6E9',
                            border: '1px solid #E8C89A',
                            borderRadius: 4,
                            padding: '12px 16px',
                            marginBottom: 20,
                            color: '#05141F',
                            fontSize: 14,
                          }}
                        >
                          Ð¡ÐºÐ¾ÑÐ¸Ð½Ð³ Ð¿ÑÐ¾Ð¹Ð´ÐµÐ½, Ð½Ð¾ Ð±Ð°Ð½Ðº ÐµÑÑ Ð½Ðµ Ð¿ÑÐ¸ÑÐ»Ð°Ð» ÑÑÐ¼Ð¼Ñ, ÑÑÐ¾Ðº, ÑÑÐ°Ð²ÐºÑ Ð¸ Ð¿Ð»Ð°ÑÑÐ¶.
                          ÐÐ°Ð¶Ð¼Ð¸ÑÐµ Â«ÐÐ±Ð½Ð¾Ð²Ð¸ÑÑÂ» ÑÐµÑÐµÐ· Ð½ÐµÑÐºÐ¾Ð»ÑÐºÐ¾ Ð¼Ð¸Ð½ÑÑ â ÐºÐ°Ðº ÑÐ¾Ð»ÑÐºÐ¾ ÑÑÐ»Ð¾Ð²Ð¸Ñ Ð¿ÑÐ¸Ð´ÑÑ,
                          Ð¾Ð½Ð¸ Ð¿Ð¾ÑÐ²ÑÑÑÑ Ð·Ð´ÐµÑÑ.
                          <br />
                          <br />
                          Ð ÐµÑÐµÐ½Ð¸Ðµ Ð¿ÑÐµÐ´Ð²Ð°ÑÐ¸ÑÐµÐ»ÑÐ½Ð¾Ðµ. ÐÐ°Ð½Ðº Ð¼Ð¾Ð¶ÐµÑ Ð¾ÑÐºÐ°Ð·Ð°ÑÑ Ð¸ Ð¿Ð¾ÑÐ»Ðµ Ð½ÐµÐ³Ð¾ â Ð¿Ð¾ Ð¿ÑÐ¾Ð²ÐµÑÐºÐµ
                          ÑÐ»ÑÐ¶Ð±Ñ Ð±ÐµÐ·Ð¾Ð¿Ð°ÑÐ½Ð¾ÑÑÐ¸, ÑÐµÑÐµÐ½Ð¸Ñ ÐºÑÐµÐ´Ð¸ÑÐ½Ð¾Ð³Ð¾ ÐºÐ¾Ð¼Ð¸ÑÐµÑÐ° Ð¸Ð»Ð¸ Ð¿Ð¾ Ð¸ÑÑÐµÑÐµÐ½Ð¸Ð¸ ÑÑÐ¾ÐºÐ°
                          Ð·Ð°ÑÐ²ÐºÐ¸. ÐÐºÐ¾Ð½ÑÐ°ÑÐµÐ»ÑÐ½ÑÐ¼ ÑÑÐ¸ÑÐ°ÐµÑÑÑ Â«ÐÑÐµÐ´Ð¸Ñ Ð²ÑÐ´Ð°Ð½Â».
                        </div>
                      ) : item?.other_conditions?.length ? (
                        item?.other_conditions?.map((condition) => {
                          return (
                            <>
                              <div style={{ background: '#F7F7F7', padding: '10px 20px', marginBottom: 20 }}>
                                <RoadAssistanceBadge condition={condition} />
                                <div className={styles.bank__info} style={{ marginBottom: 20 }}>
                                  <div
                                    className={styles.bank__info_row}
                                    style={{
                                      gridColumn: '1 / span 2',
                                    }}
                                  >
                                    <p className={styles.bank__info_title}>Ð¡ÑÐ¼Ð¼Ð° Ð·Ð°Ð¹Ð¼Ð°</p>
                                    <p className={styles.bank__info_sub}>{formatNumber(condition?.amount)}</p>
                                  </div>
                                  <div className={styles.bank__info_row}>
                                    <p className={styles.bank__info_title}>ÐÐµÑÐ²Ð¾Ð½Ð°ÑÐ°Ð»ÑÐ½ÑÐ¹ Ð²Ð·Ð½Ð¾Ñ, ÑÐµÐ½Ð³Ðµ</p>
                                    <p className={styles.bank__info_sub}>{formatNumber(condition?.initialFee)}</p>
                                  </div>
                                  {item.bank.id !== BANKS.ALTYN &&
                                  item.bank.id !== BANKS.SHINHAN &&
                                  condition?.insurance !== false &&
                                  ((condition?.kasko_amount != null && condition?.kasko_amount !== 0) ||
                                    (item?.kasko_amount != null && item?.kasko_amount !== 0) ||
                                    (condition?.cascoAmount != null && condition?.cascoAmount !== 0) ||
                                    (item?.cascoAmount != null && item?.cascoAmount !== 0)) ? (
                                    <div className={styles.bank__info_row}>
                                      <p className={styles.bank__info_title}>Ð¡ÑÑÐ°ÑÐ¾Ð²Ð°Ð½Ð¸Ðµ ÐÐÐ¡ÐÐ</p>
                                      <p className={styles.bank__info_sub}>
                                        {formatNumber(
                                          condition?.cascoAmount != null && condition.cascoAmount !== 0
                                            ? condition.cascoAmount
                                            : item?.cascoAmount != null && item.cascoAmount !== 0
                                            ? item.cascoAmount
                                            : condition?.kasko_amount != null && condition?.kasko_amount !== 0
                                            ? condition.kasko_amount
                                            : item?.kasko_amount != null && item?.kasko_amount !== 0
                                            ? item.kasko_amount
                                            : 0
                                        )}
                                      </p>
                                    </div>
                                  ) : null}
                                  {item.bank.id !== BANKS.HALYK && (condition?.ns_amount || item?.ns_amount) ? (
                                    <div className={styles.bank__info_row}>
                                      <p className={styles.bank__info_title}>Ð¡ÑÑÐ°ÑÐ¾Ð²Ð°Ð½Ð¸Ðµ ÐÐ¡</p>
                                      <p className={styles.bank__info_sub}>
                                        {formatNumber(
                                          condition?.ns_amount != null && condition.ns_amount !== 0
                                            ? condition.ns_amount
                                            : item?.ns_amount != null && item.ns_amount !== 0
                                            ? item.ns_amount
                                            : 0
                                        )}
                                      </p>
                                    </div>
                                  ) : null}
                                  {condition?.cascoTerm > 0 ? (
                                    <div className={styles.bank__info_row}>
                                      <p className={styles.bank__info_title}>Ð¡ÑÐ¾Ðº ÑÑÑÐ°ÑÐ¾Ð²Ð°Ð½Ð¸Ñ ÐÐÐ¡ÐÐ</p>
                                      <p className={styles.bank__info_sub}>{condition?.cascoTerm} Ð¼.</p>
                                    </div>
                                  ) : null}
                                  {condition?.road_assistance !== false && condition?.road_assistance_term > 0 ? (
                                    <div className={styles.bank__info_row}>
                                      <p className={styles.bank__info_title}>Ð¡ÑÐ¾Ðº ÑÑÑÐ°ÑÐ¾Ð²Ð°Ð½Ð¸Ñ</p>
                                      <p className={styles.bank__info_sub}>{condition?.road_assistance_term}</p>
                                    </div>
                                  ) : null}
                                  {condition?.road_assistance !== false &&
                                  condition?.road_assistance_name &&
                                  condition?.road_assistance_sum ? (
                                    <div className={styles.bank__info_row}>
                                      <p className={styles.bank__info_title}>
                                        Ð¡ÑÑÐ°ÑÐ¾Ð²Ð°Ð½Ð¸Ðµ {condition?.road_assistance_name}
                                      </p>
                                      <p className={styles.bank__info_sub}>{condition?.road_assistance_sum}</p>
                                    </div>
                                  ) : null}
                                  {condition?.comission ? (
                                    <div className={styles.bank__info_row}>
                                      <p className={styles.bank__info_title}>ÐÐ¾Ð¼Ð¸ÑÑÐ¸Ñ Ð±Ð°Ð½ÐºÐ°, ÑÐµÐ½Ð³Ðµ:</p>
                                      <p className={styles.bank__info_sub}>
                                        {formatNumber(condition?.comissionSum)}
                                      </p>
                                    </div>
                                  ) : null}

                                  <div className={styles.bank__info_row}>
                                    <p className={styles.bank__info_title}>Ð¡ÑÐ¾Ðº ÐºÑÐµÐ´Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ñ:</p>
                                    <p className={styles.bank__info_sub}>{condition?.term} Ð¼.</p>
                                  </div>
                                  <div className={styles.bank__info_row}>
                                    <p className={styles.bank__info_title}>ÐÑÐ¾ÑÐµÐ½ÑÐ½Ð°Ñ ÑÑÐ°Ð²ÐºÐ° (Ð³Ð¾Ð´Ð¾Ð²ÑÑ):</p>
                                    <p className={styles.bank__info_sub}>
                                      {rateUnknown(item, condition) ? 'Ð±Ð°Ð½Ðº Ð½Ðµ Ð¿ÑÐ¸ÑÐ»Ð°Ð»' : `${condition?.rate}%`}
                                    </p>
                                  </div>
                                  {item.bank.id != BANKS.EURAZ && (
                                    <div className={styles.bank__info_row}>
                                      <p className={styles.bank__info_title}>ÐÐ¶ÐµÐ¼ÐµÑÑÑÐ½ÑÐ¹ Ð¿Ð»Ð°ÑÐµÐ¶, ÑÐµÐ½Ð³Ðµ:</p>
                                      <p className={styles.bank__info_sub}>
                                        {paymentUnknown(item, condition)
                                          ? 'Ð±Ð°Ð½Ðº Ð½Ðµ Ð¿ÑÐ¸ÑÐ»Ð°Ð»'
                                          : formatNumber(condition?.payment)}
                                      </p>
                                    </div>
                                  )}
                                  {condition?.secondRateMonthlyPayment ? (
                                    <div className={styles.bank__info_row}>
                                      <p className={styles.bank__info_title}>
                                      ÐÐ¶ÐµÐ¼ÐµÑÑÑÐ½ÑÐ¹ Ð¿Ð»Ð°ÑÐµÐ¶ Ð²Ð¾ Ð²ÑÐ¾ÑÐ¾Ð¼ Ð¿ÐµÑÐ¸Ð¾Ð´Ðµ Ð¿Ð¾ Ð¾ÐºÐ¾Ð½ÑÐ°Ð½Ð¸Ñ Ð»ÑÐ³Ð¾ÑÐ½Ð¾Ð³Ð¾ Ð¿ÐµÑÐ¸Ð¾Ð´Ð°:
                                      </p>
                                      <p className={styles.bank__info_sub}>{condition?.secondRateMonthlyPayment}</p>
                                    </div>
                                  ) : null}
                                  {condition?.secondPayment ? (
                                    <div className={styles.bank__info_row}>
                                      <p className={styles.bank__info_title}>ÐÐ¶ÐµÐ¼ÐµÑÑÑÐ½ÑÐ¹ Ð¿Ð»Ð°ÑÐµÐ¶:</p>
                                      <p className={styles.bank__info_sub}>{condition?.secondPayment}</p>
                                    </div>
                                  ) : null}
                                  {item?.bank?.id == BANKS.EURAZ && condition?.additionalServices ? (
                                    <div className={styles.bank__info_row}>
                                      <p className={styles.bank__info_title}>ÐÐ¾Ð¿. ÑÑÐ»ÑÐ³Ð¸:</p>
                                      <p className={styles.bank__info_sub}>{condition?.additionalServices}</p>
                                    </div>
                                  ) : null}
                                  {isSapaConveyor(item?.bank?.id) &&
                                  (condition?.life_insurance_amount || item?.life_insurance_amount) ? (
                                    <div className={styles.bank__info_row}>
                                      <p className={styles.bank__info_title}>Ð¡ÑÑÐ°ÑÐ¾Ð²Ð°Ð½Ð¸Ðµ Ð¶Ð¸Ð·Ð½Ð¸:</p>
                                      <p className={styles.bank__info_sub}>
                                        {condition?.life_insurance_amount || item?.life_insurance_amount}
                                      </p>
                                    </div>
                                  ) : null}
                                  {isSapaConveyor(item?.bank?.id) &&
                                  (condition?.credit_holiday_amount || item?.credit_holiday_amount) ? (
                                    <div className={styles.bank__info_row}>
                                      <p className={styles.bank__info_title}>ÐÐ¾Ð¼Ð¾ÑÑ Ð½Ð° Ð´Ð¾ÑÐ¾Ð³Ðµ:</p>
                                      <p className={styles.bank__info_sub}>
                                        {formatNumber(condition?.credit_holiday_amount || item?.credit_holiday_amount)}
                                      </p>
                                    </div>
                                  ) : null}
                                  {isSapaConveyor(item?.bank?.id) &&
                                  (condition?.car_check_amount || item?.car_check_amount) ? (
                                    <div className={styles.bank__info_row}>
                                      <p className={styles.bank__info_title}>ÐÑÐ¾Ð²ÐµÑÐºÐ° Ð°Ð²ÑÐ¾:</p>
                                      <p className={styles.bank__info_sub}>
                                        {formatNumber(condition?.car_check_amount || item?.car_check_amount)}
                                      </p>
                                    </div>
                                  ) : null}
                                </div>

                                {condition?.conditions?.length ? (
                                  <>
                                    <div
                                      style={{
                                        display: 'grid',
                                        gap: 10,
                                        gridTemplateColumns: '20px 1fr',
                                        marginBottom: 20,
                                      }}
                                    >
                                      <RiErrorWarningLine height={20} width={20} color="#B45436" />
                                      <p
                                        style={{
                                          color: '#05141F',
                                          fontSize: 14,
                                          fontWeight: 600,
                                        }}
                                      >
                                        ÐÑ Ð¼Ð¾Ð¶ÐµÑÐµ Ð²ÑÐ±ÑÐ°ÑÑ ÑÑÐ¾Ñ Ð²Ð°ÑÐ¸Ð°Ð½Ñ Ð² ÑÐ»ÑÑÐ°Ðµ Ð¿Ð¾Ð³Ð°ÑÐµÐ½Ð¸Ñ ÐºÑÐµÐ´Ð¸ÑÐ¾Ð² Ð¿Ð¾ ÑÐ»ÐµÐ´ÑÑÑÐ¸Ð¼
                                        Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÐ°Ð¼:
                                      </p>
                                    </div>
                                    {condition?.conditions?.map((openedOffer) => {
                                      return (
                                        <>
                                          <div
                                            className={styles.bank__info}
                                            style={{ background: '#fff', padding: 10, marginBottom: 20 }}
                                          >
                                            <div className={styles.bank__info_row}>
                                              <p className={styles.bank__info_title}>ÐÐ¾Ð¼ÐµÑ Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÐ°</p>
                                              <p className={styles.bank__info_sub} style={{ wordBreak: 'break-all' }}>
                                                {openedOffer?.contractNumber}
                                              </p>
                                            </div>
                                            {item.bank.id != BANKS.EURAZ && (
                                              <div className={styles.bank__info_row}>
                                                <p className={styles.bank__info_title}>ÐÐ¶ÐµÐ¼ÐµÑÑÑÐ½ÑÐ¹ Ð¿Ð»Ð°ÑÐµÐ¶, ÑÐµÐ½Ð³Ðµ:</p>
                                                <p className={styles.bank__info_sub}>
                                                  {formatNumber(openedOffer?.monthlyInstalmentAmountKZ)}
                                                </p>
                                              </div>
                                            )}

                                            {condition?.secondRateMonthlyPayment ? (
                                              <div className={styles.bank__info_row}>
                                                <p className={styles.bank__info_title}>
                                                ÐÐ¶ÐµÐ¼ÐµÑÑÑÐ½ÑÐ¹ Ð¿Ð»Ð°ÑÐµÐ¶ Ð²Ð¾ Ð²ÑÐ¾ÑÐ¾Ð¼ Ð¿ÐµÑÐ¸Ð¾Ð´Ðµ Ð¿Ð¾ Ð¾ÐºÐ¾Ð½ÑÐ°Ð½Ð¸Ñ Ð»ÑÐ³Ð¾ÑÐ½Ð¾Ð³Ð¾ Ð¿ÐµÑÐ¸Ð¾Ð´Ð°:
                                                </p>
                                                <p className={styles.bank__info_sub}>
                                                  {condition?.secondRateMonthlyPayment}
                                                </p>
                                              </div>
                                            ) : null}
                                            {condition?.secondPayment ? (
                                              <div className={styles.bank__info_row}>
                                                <p className={styles.bank__info_title}>ÐÐ¶ÐµÐ¼ÐµÑÑÑÐ½ÑÐ¹ Ð¿Ð»Ð°ÑÐµÐ¶:</p>
                                                <p className={styles.bank__info_sub}>
                                                  {condition?.secondPayment}
                                                </p>
                                              </div>
                                            ) : null}
                                            <div className={styles.bank__info_row}>
                                              <p className={styles.bank__info_title}>ÐÐ°Ð½Ðº:</p>
                                              <p className={styles.bank__info_sub}>{openedOffer?.finInstiut}</p>
                                            </div>
                                            <div className={styles.bank__info_row}>
                                              <p className={styles.bank__info_title}>ÐÑÑÐ°ÑÐ¾Ðº Ð¿Ð¾Ð³Ð°ÑÐµÐ½Ð¸Ñ, ÑÐµÐ½Ð³Ðµ:</p>
                                              <p className={styles.bank__info_sub}>
                                                {formatNumber(openedOffer?.outstandingAmountKZ)}
                                              </p>
                                            </div>
                                            {isSapaConveyor(item?.bank?.id) &&
                                            (condition?.life_insurance_amount || item?.life_insurance_amount) ? (
                                              <div className={styles.bank__info_row}>
                                                <p className={styles.bank__info_title}>Ð¡ÑÑÐ°ÑÐ¾Ð²Ð°Ð½Ð¸Ðµ Ð¶Ð¸Ð·Ð½Ð¸:</p>
                                                <p className={styles.bank__info_sub}>
                                                  {condition?.life_insurance_amount || item?.life_insurance_amount}
                                                </p>
                                              </div>
                                            ) : null}
                                          </div>
                                        </>
                                      );
                                    })}
                                  </>
                                ) : null}

                                <div
                                  style={{
                                    display: 'flex',
                                    justifyContent: 'flex-start',
                                    marginTop: 20,
                                  }}
                                >
                                  {/* {item?.selected && deal?.paymentType?.id == PAYMENT_TYPES_CREDIT_CARD && (
                                        <Button
                                          text="ÐÐ¿Ð»Ð°ÑÐ¸ÑÑ ÐºÐ°ÑÑÐ¾Ð¹"
                                          fill
                                          onClick={() => cardPayment(item, condition)}
                                        />
                                      )}
                                      {item?.selected && deal?.paymentType?.id == PAYMENT_TYPES_CREDIT_INVOICE && (
                                        <Button text="ÐÐµÑÐµÐ¹ÑÐ¸ Ð² Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÑ" fill onClick={() => getInvoice(item)} />
                                      )} */}
                                  {
                                    <Button
                                      text="ÐÑÐ±ÑÐ°ÑÑ Ð¿ÑÐµÐ´Ð»Ð¾Ð¶ÐµÐ½Ð¸Ðµ"
                                      fill
                                      disabled={isExpired || awaitingMyCarRework(item, BANKS.MYCAR)}
                                      onClick={() => chooseBank(item, condition?.offerType)}
                                    />
                                  }
                                </div>
                              </div>
                            </>
                          );
                        })
                      ) : (
                        <>
                          <div className={styles.bank__info}>
                            {item?.loan_amount ? (
                              <div className={styles.bank__info_row} style={{ gridColumn: '1 / span 2' }}>
                                <p className={styles.bank__info_title}>Ð¡ÑÐ¼Ð¼Ð° Ð·Ð°Ð¹Ð¼Ð°</p>
                                <p className={styles.bank__info_sub}>{formatNumber(item?.loan_amount)}</p>
                              </div>
                            ) : null}

                            <div className={styles.bank__info_row}>
                              <p className={styles.bank__info_title}>ÐÐµÑÐ²Ð¾Ð½Ð°ÑÐ°Ð»ÑÐ½ÑÐ¹ Ð²Ð·Ð½Ð¾Ñ, ÑÐµÐ½Ð³Ðµ</p>
                              <p className={styles.bank__info_sub}>{formatNumber(item?.initialFee)}</p>
                            </div>
                            <div className={styles.bank__info_row}>
                              <p className={styles.bank__info_title}>Ð¡ÑÐ¾Ðº ÐºÑÐµÐ´Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ñ:</p>
                              <p className={styles.bank__info_sub}>{item?.period} Ð¼.</p>
                            </div>
                            {item?.road_assistance_term > 0 ? (
                              <div className={styles.bank__info_row}>
                                <p className={styles.bank__info_title}>Ð¡ÑÐ¾Ðº ÑÑÑÐ°ÑÐ¾Ð²Ð°Ð½Ð¸Ñ</p>
                                <p className={styles.bank__info_sub}>{item?.road_assistance_term}</p>
                              </div>
                            ) : null}
                            {item?.road_assistance_name && item?.road_assistance_sum ? (
                              <div className={styles.bank__info_row}>
                                <p className={styles.bank__info_title}>Ð¡ÑÑÐ°ÑÐ¾Ð²Ð°Ð½Ð¸Ðµ {item?.road_assistance_name}</p>
                                <p className={styles.bank__info_sub}>{item?.road_assistance_sum}</p>
                              </div>
                            ) : null}
                            {item.bank.id !== BANKS.SHINHAN &&
                            (item?.cascoAmount != null || item?.kasko_amount != null) ? (
                              <div className={styles.bank__info_row}>
                                <p className={styles.bank__info_title}>Ð¡ÑÑÐ°ÑÐ¾Ð²Ð°Ð½Ð¸Ðµ ÐÐÐ¡ÐÐ</p>
                                <p className={styles.bank__info_sub}>
                                  {formatNumber(
                                    item?.cascoAmount != null && item.cascoAmount !== 0
                                      ? item.cascoAmount
                                      : item?.kasko_amount === 0 || item?.kasko_amount === null
                                      ? 0
                                      : item?.kasko_amount
                                  )}
                                </p>
                              </div>
                            ) : null}
                            {item?.ns_amount ? (
                              <div className={styles.bank__info_row}>
                                <p className={styles.bank__info_title}>Ð¡ÑÑÐ°ÑÐ¾Ð²Ð°Ð½Ð¸Ðµ ÐÐ¡</p>
                                <p className={styles.bank__info_sub}>{formatNumber(item?.ns_amount)}</p>
                              </div>
                            ) : null}
                            {item?.cascoTerm > 0 ? (
                              <div className={styles.bank__info_row}>
                                <p className={styles.bank__info_title}>Ð¡ÑÐ¾Ðº ÑÑÑÐ°ÑÐ¾Ð²Ð°Ð½Ð¸Ñ ÐÐÐ¡ÐÐ</p>
                                <p className={styles.bank__info_sub}>{item?.cascoTerm} Ð¼.</p>
                              </div>
                            ) : null}
                            <div className={styles.bank__info_row}>
                              <p className={styles.bank__info_title}>ÐÑÐ¾ÑÐµÐ½ÑÐ½Ð°Ñ ÑÑÐ°Ð²ÐºÐ° (Ð³Ð¾Ð´Ð¾Ð²ÑÑ):</p>
                              <p className={styles.bank__info_sub}>
                                {rateUnknown(item, null) ? 'Ð±Ð°Ð½Ðº Ð½Ðµ Ð¿ÑÐ¸ÑÐ»Ð°Ð»' : `${item?.percent}%`}
                              </p>
                            </div>
                            {item.bank.id != BANKS.EURAZ && (
                              <div className={styles.bank__info_row}>
                                <p className={styles.bank__info_title}>ÐÐ¶ÐµÐ¼ÐµÑÑÑÐ½ÑÐ¹ Ð¿Ð»Ð°ÑÐµÐ¶, ÑÐµÐ½Ð³Ðµ:</p>
                                <p className={styles.bank__info_sub}>
                                  {paymentUnknown(item, null)
                                    ? 'Ð±Ð°Ð½Ðº Ð½Ðµ Ð¿ÑÐ¸ÑÐ»Ð°Ð»'
                                    : formatNumber(item?.monthlyPayment)}
                                </p>
                              </div>
                            )}

                            {item?.secondRateMonthlyPayment ? (
                              <div className={styles.bank__info_row}>
                                <p className={styles.bank__info_title}>
                                ÐÐ¶ÐµÐ¼ÐµÑÑÑÐ½ÑÐ¹ Ð¿Ð»Ð°ÑÐµÐ¶ Ð²Ð¾ Ð²ÑÐ¾ÑÐ¾Ð¼ Ð¿ÐµÑÐ¸Ð¾Ð´Ðµ Ð¿Ð¾ Ð¾ÐºÐ¾Ð½ÑÐ°Ð½Ð¸Ñ Ð»ÑÐ³Ð¾ÑÐ½Ð¾Ð³Ð¾ Ð¿ÐµÑÐ¸Ð¾Ð´Ð°:
                                </p>
                                <p className={styles.bank__info_sub}>{item?.secondRateMonthlyPayment}</p>
                              </div>
                            ) : null}
                            {item?.secondPayment ? (
                              <div className={styles.bank__info_row}>
                                  <p className={styles.bank__info_title}>ÐÑÐ¾ÑÐ¾Ð¹ Ð¿Ð»Ð°ÑÐµÐ¶ Ð¿Ð¾ ÐºÑÐµÐ´Ð¸ÑÑ:</p>
                                  <p className={styles.bank__info_sub}>{item?.secondPayment}</p>
                              </div>
                            ) : null}
                            {item?.bank?.id == BANKS.HALYK ? (
                              <div className={styles.bank__info_row}>
                                <p className={styles.bank__info_title}>Ð¡ÑÐ±ÑÐ¸Ð´Ð¸Ñ:</p>
                                <p className={styles.bank__info_sub}>{subsidy ? 'ÐÐ°' : 'ÐÐµÑ'}</p>
                              </div>
                            ) : null}
                            {item?.bank?.id == BANKS.EURAZ && item?.additionalServices ? (
                              <div className={styles.bank__info_row}>
                                <p className={styles.bank__info_title}>ÐÐ¾Ð¿. ÑÑÐ»ÑÐ³Ð¸:</p>
                                <p className={styles.bank__info_sub}>{item?.additionalServices}</p>
                              </div>
                            ) : null}
                          </div>
                          {isJetFin(item) ? (
                            <p style={{ color: '#7A6A55', fontSize: 13, marginTop: 10 }}>
                              Ð ÐµÑÐµÐ½Ð¸Ðµ Ð¿ÑÐµÐ´Ð²Ð°ÑÐ¸ÑÐµÐ»ÑÐ½Ð¾Ðµ: Ð±Ð°Ð½Ðº Ð¼Ð¾Ð¶ÐµÑ Ð¾ÑÐºÐ°Ð·Ð°ÑÑ Ð¸ Ð¿Ð¾ÑÐ»Ðµ Ð¾Ð´Ð¾Ð±ÑÐµÐ½Ð¸Ñ
                              ÑÐºÐ¾ÑÐ¸Ð½Ð³Ð° â Ð¿Ð¾ Ð¿ÑÐ¾Ð²ÐµÑÐºÐµ ÑÐ»ÑÐ¶Ð±Ñ Ð±ÐµÐ·Ð¾Ð¿Ð°ÑÐ½Ð¾ÑÑÐ¸ Ð¸Ð»Ð¸ ÑÐµÑÐµÐ½Ð¸Ñ ÐºÑÐµÐ´Ð¸ÑÐ½Ð¾Ð³Ð¾
                              ÐºÐ¾Ð¼Ð¸ÑÐµÑÐ°. ÐÐºÐ¾Ð½ÑÐ°ÑÐµÐ»ÑÐ½ÑÐ¼ ÑÑÐ¸ÑÐ°ÐµÑÑÑ Â«ÐÑÐµÐ´Ð¸Ñ Ð²ÑÐ´Ð°Ð½Â».
                            </p>
                          ) : null}
                          <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: 20 }}>
                            {/* {item?.selected && deal?.paymentType?.id == PAYMENT_TYPES_CREDIT_CARD && (
                                  <Button text="ÐÐ¿Ð»Ð°ÑÐ¸ÑÑ ÐºÐ°ÑÑÐ¾Ð¹" fill onClick={() => cardPayment(item)} />
                                )}
                                {item?.selected && deal?.paymentType?.id == PAYMENT_TYPES_CREDIT_INVOICE && (
                                  <Button text="ÐÐµÑÐµÐ¹ÑÐ¸ Ð² Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÑ" fill onClick={() => getInvoice(item)} />
                                )} */}
                            {
                              <Button
                                text="ÐÑÐ±ÑÐ°ÑÑ Ð¿ÑÐµÐ´Ð»Ð¾Ð¶ÐµÐ½Ð¸Ðµ"
                                fill
                                disabled={isExpired || awaitingMyCarRework(item, BANKS.MYCAR)}
                                onClick={() => chooseBank(item)}
                              />
                            }
                          </div>
                        </>
                      )}
                    </div>
                  </>
                )}
              </div>
            );
          })
        )}

        <div id="printableArea">
          <h3
            className={styles.title}
            style={{
              display: 'flex',
              alignItems: 'center',
              marginBottom: 20,
            }}
          >
            ÐÑÐ²ÐµÑÑ Ð¾Ñ Ð±Ð°Ð½ÐºÐ¾Ð²
          </h3>
          {appeals
            ?.filter((appeal) => appeal?.statusId == BANK_CREDIT_ACCEPTED || appeal?.statusId == BANK_CREDIT_REGISTERED)
            .map((item) => {
              return (
                <div className={styles.bank}>
                  <div className={styles.bank__row}>
                    <div className={styles.bank__img}>
                      <img src={item?.bank?.logo} />
                    </div>
                    <p className={styles.bank_name}>{item?.bank?.name}</p>
                    <p
                      className={`${styles.status} ${
                        item?.statusId == BANK_CREDIT_ACCEPTED && styles.status__accepted
                      } ${item?.statusId == BANK_CREDIT_REJECTED && styles.status__rejected}`}
                    >
                      {BANK_CREDIT_STATUSES[item?.statusId]}
                    </p>
                  </div>
                  {item?.errorMessage && (
                    <div style={{ padding: '0 20px', marginBottom: 20 }}>
                      <p className={styles.sub} style={{ color: '#EE7171', wordBreak: 'break-all' }}>
                        {bankErrorSummary(item?.errorMessage)}
                      </p>
                    </div>
                  )}
                  {/* Â«ÐÐ´Ð¾Ð±ÑÐµÐ½Ð¾ Ñ Ð´Ð¾ÑÐ°Ð±Ð¾ÑÐºÐ¾Ð¹Â»: Ð±Ð°Ð½Ðº Ð¶Ð´ÑÑ Ð´Ð¾ÐºÑÐ¼ÐµÐ½Ñ â Ð¾ÑÐ¿ÑÐ°Ð²Ð»ÑÐµÐ¼ Ð¸Ð· ÐºÐ°ÑÑÐ¾ÑÐºÐ¸. */}
                  {isMyCarConditionCase(item, BANKS.MYCAR) && (
                    <div style={{ padding: '0 20px', marginBottom: 20 }}>
                      <p className={styles.sub}>
                        ÐÐ°Ð½Ðº Ð¾Ð´Ð¾Ð±ÑÐ¸Ð» Ð·Ð°ÑÐ²ÐºÑ Ð½Ð° ÑÐ²Ð¾Ð¸Ñ ÑÑÐ»Ð¾Ð²Ð¸ÑÑ â Ð¾Ð½Ð¸ Ð¿Ð¾ÐºÐ°Ð·Ð°Ð½Ñ Ð½Ð¸Ð¶Ðµ. ÐÑÐ»Ð¸ ÐºÐ»Ð¸ÐµÐ½Ñ
                        ÑÐ¾Ð³Ð»Ð°ÑÐµÐ½, Ð½Ð°Ð¶Ð¼Ð¸ÑÐµ Â«ÐÑÐ±ÑÐ°ÑÑ Ð¿ÑÐµÐ´Ð»Ð¾Ð¶ÐµÐ½Ð¸ÐµÂ»: ÑÐ¾Ð³Ð»Ð°ÑÐ¸Ðµ ÑÐ¹Ð´ÑÑ Ð² MyCar.
                      </p>
                    </div>
                  )}
                  {needsMyCarUpdate(item, BANKS.MYCAR) && (
                    <div style={{ padding: '0 20px' }}>
                      <MyCarUpdateApplication
                      appealId={item?.id}
                      onSuccess={() => {
                        init();
                        update && update();
                      }}
                    />
                    </div>
                  )}
                  {(item?.statusId == BANK_CREDIT_ACCEPTED || item?.statusId == BANK_CREDIT_REGISTERED) && (
                    <>
                      <div>
                        <p className={styles.sub}>
                        {conditionsNotReceived(item)
                          ? 'ÐÐ°Ð½Ðº Ð¿ÑÐµÐ´Ð²Ð°ÑÐ¸ÑÐµÐ»ÑÐ½Ð¾ Ð¾Ð´Ð¾Ð±ÑÐ¸Ð» Ð·Ð°ÑÐ²ÐºÑ. Ð£ÑÐ»Ð¾Ð²Ð¸Ñ ÐµÑÑ Ð½Ðµ Ð¿ÑÐ¸ÑÐ»Ð¸.'
                          : 'ÐÐ»Ð¸ÐµÐ½ÑÑ Ð¾Ð´Ð¾Ð±ÑÐµÐ½ ÐºÑÐµÐ´Ð¸Ñ Ð½Ð° ÑÐ»ÐµÐ´ÑÑÑÐ¸Ñ ÑÑÐ»Ð¾Ð²Ð¸ÑÑ:'}
                      </p>
                        {conditionsNotReceived(item) ? (
                        <div
                          style={{
                            background: '#FFF6E9',
                            border: '1px solid #E8C89A',
                            borderRadius: 4,
                            padding: '12px 16px',
                            marginBottom: 20,
                            color: '#05141F',
                            fontSize: 14,
                          }}
                        >
                          Ð¡ÐºÐ¾ÑÐ¸Ð½Ð³ Ð¿ÑÐ¾Ð¹Ð´ÐµÐ½, Ð½Ð¾ Ð±Ð°Ð½Ðº ÐµÑÑ Ð½Ðµ Ð¿ÑÐ¸ÑÐ»Ð°Ð» ÑÑÐ¼Ð¼Ñ, ÑÑÐ¾Ðº, ÑÑÐ°Ð²ÐºÑ Ð¸ Ð¿Ð»Ð°ÑÑÐ¶.
                          ÐÐ°Ð¶Ð¼Ð¸ÑÐµ Â«ÐÐ±Ð½Ð¾Ð²Ð¸ÑÑÂ» ÑÐµÑÐµÐ· Ð½ÐµÑÐºÐ¾Ð»ÑÐºÐ¾ Ð¼Ð¸Ð½ÑÑ â ÐºÐ°Ðº ÑÐ¾Ð»ÑÐºÐ¾ ÑÑÐ»Ð¾Ð²Ð¸Ñ Ð¿ÑÐ¸Ð´ÑÑ,
                          Ð¾Ð½Ð¸ Ð¿Ð¾ÑÐ²ÑÑÑÑ Ð·Ð´ÐµÑÑ.
                          <br />
                          <br />
                          Ð ÐµÑÐµÐ½Ð¸Ðµ Ð¿ÑÐµÐ´Ð²Ð°ÑÐ¸ÑÐµÐ»ÑÐ½Ð¾Ðµ. ÐÐ°Ð½Ðº Ð¼Ð¾Ð¶ÐµÑ Ð¾ÑÐºÐ°Ð·Ð°ÑÑ Ð¸ Ð¿Ð¾ÑÐ»Ðµ Ð½ÐµÐ³Ð¾ â Ð¿Ð¾ Ð¿ÑÐ¾Ð²ÐµÑÐºÐµ
                          ÑÐ»ÑÐ¶Ð±Ñ Ð±ÐµÐ·Ð¾Ð¿Ð°ÑÐ½Ð¾ÑÑÐ¸, ÑÐµÑÐµÐ½Ð¸Ñ ÐºÑÐµÐ´Ð¸ÑÐ½Ð¾Ð³Ð¾ ÐºÐ¾Ð¼Ð¸ÑÐµÑÐ° Ð¸Ð»Ð¸ Ð¿Ð¾ Ð¸ÑÑÐµÑÐµÐ½Ð¸Ð¸ ÑÑÐ¾ÐºÐ°
                          Ð·Ð°ÑÐ²ÐºÐ¸. ÐÐºÐ¾Ð½ÑÐ°ÑÐµÐ»ÑÐ½ÑÐ¼ ÑÑÐ¸ÑÐ°ÐµÑÑÑ Â«ÐÑÐµÐ´Ð¸Ñ Ð²ÑÐ´Ð°Ð½Â».
                        </div>
                      ) : item?.other_conditions?.length ? (
                          item?.other_conditions?.map((condition) => {
                            return (
                              <>
                                <div style={{ background: '#F7F7F7', padding: '10px 20px', marginBottom: 20 }}>
                                  <RoadAssistanceBadge condition={condition} />
                                  <div className={styles.bank__info} style={{ marginBottom: 20 }}>
                                    <div
                                      className={styles.bank__info_row}
                                      style={{
                                        gridColumn: '1 / span 2',
                                      }}
                                    >
                                      <p className={styles.bank__info_title}>Ð¡ÑÐ¼Ð¼Ð° Ð·Ð°Ð¹Ð¼Ð°</p>
                                      <p className={styles.bank__info_sub}>{formatNumber(condition?.amount)}</p>
                                    </div>
                                    <div className={styles.bank__info_row}>
                                      <p className={styles.bank__info_title}>ÐÐµÑÐ²Ð¾Ð½Ð°ÑÐ°Ð»ÑÐ½ÑÐ¹ Ð²Ð·Ð½Ð¾Ñ, ÑÐµÐ½Ð³Ðµ</p>
                                      <p className={styles.bank__info_sub}>
                                        {condition?.initialFee
                                          ? formatNumber(condition?.initialFee)
                                          : formatNumber(item?.initialFee)}
                                      </p>
                                    </div>
                                    {item.bank.id != BANKS.EURAZ && (
                                      <div className={styles.bank__info_row}>
                                        <p className={styles.bank__info_title}>ÐÐ¶ÐµÐ¼ÐµÑÑÑÐ½ÑÐ¹ Ð¿Ð»Ð°ÑÐµÐ¶, ÑÐµÐ½Ð³Ðµ:</p>
                                        <p className={styles.bank__info_sub}>
                                          {formatNumber(condition?.monthlyInstalmentAmountKZ)}
                                        </p>
                                      </div>
                                    )}

                                    {condition?.secondRateMonthlyPayment ? (
                                      <div className={styles.bank__info_row}>
                                        <p className={styles.bank__info_title}>
                                        ÐÐ¶ÐµÐ¼ÐµÑÑÑÐ½ÑÐ¹ Ð¿Ð»Ð°ÑÐµÐ¶ Ð²Ð¾ Ð²ÑÐ¾ÑÐ¾Ð¼ Ð¿ÐµÑÐ¸Ð¾Ð´Ðµ Ð¿Ð¾ Ð¾ÐºÐ¾Ð½ÑÐ°Ð½Ð¸Ñ Ð»ÑÐ³Ð¾ÑÐ½Ð¾Ð³Ð¾ Ð¿ÐµÑÐ¸Ð¾Ð´Ð°:
                                        </p>
                                        <p className={styles.bank__info_sub}>{condition?.secondRateMonthlyPayment}</p>
                                      </div>
                                    ) : null}
                                    {condition?.secondPayment ? (
                                      <div className={styles.bank__info_row}>
                                        <p className={styles.bank__info_title}>ÐÐ¶ÐµÐ¼ÐµÑÑÑÐ½ÑÐ¹ Ð¿Ð»Ð°ÑÐµÐ¶:</p>
                                        <p className={styles.bank__info_sub}>{condition?.secondPayment}</p>
                                      </div>
                                    ) : null}
                                    {condition?.comission ? (
                                      <div className={styles.bank__info_row}>
                                        <p className={styles.bank__info_title}>ÐÐ¾Ð¼Ð¸ÑÑÐ¸Ñ Ð±Ð°Ð½ÐºÐ°, ÑÐµÐ½Ð³Ðµ:</p>
                                        <p className={styles.bank__info_sub}>{formatNumber(condition?.comissionSum)}</p>
                                      </div>
                                    ) : null}
                                    <div className={styles.bank__info_row}>
                                      <p className={styles.bank__info_title}>Ð¡ÑÐ¾Ðº ÐºÑÐµÐ´Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ñ:</p>
                                      <p className={styles.bank__info_sub}>{condition?.term} Ð¼.</p>
                                    </div>
                                    <div className={styles.bank__info_row}>
                                      <p className={styles.bank__info_title}>ÐÑÐ¾ÑÐµÐ½ÑÐ½Ð°Ñ ÑÑÐ°Ð²ÐºÐ° (Ð³Ð¾Ð´Ð¾Ð²ÑÑ):</p>
                                      <p className={styles.bank__info_sub}>{condition?.rate}%</p>
                                    </div>
                                    {item.bank.id != BANKS.EURAZ && (
                                      <div className={styles.bank__info_row}>
                                        <p className={styles.bank__info_title}>ÐÐ¶ÐµÐ¼ÐµÑÑÑÐ½ÑÐ¹ Ð¿Ð»Ð°ÑÐµÐ¶, ÑÐµÐ½Ð³Ðµ:</p>
                                        <p className={styles.bank__info_sub}>{formatNumber(condition?.payment)}</p>
                                      </div>
                                    )}
                                  </div>

                                  {condition?.conditions?.length ? (
                                    <>
                                      <div
                                        style={{
                                          display: 'grid',
                                          gap: 10,
                                          gridTemplateColumns: '20px 1fr',
                                          marginBottom: 20,
                                        }}
                                      >
                                        <RiErrorWarningLine height={20} width={20} color="#B45436" />
                                        <p
                                          style={{
                                            color: '#05141F',
                                            fontSize: 14,
                                            fontWeight: 600,
                                          }}
                                        >
                                          ÐÑ Ð¼Ð¾Ð¶ÐµÑÐµ Ð²ÑÐ±ÑÐ°ÑÑ ÑÑÐ¾Ñ Ð²Ð°ÑÐ¸Ð°Ð½Ñ Ð² ÑÐ»ÑÑÐ°Ðµ Ð¿Ð¾Ð³Ð°ÑÐµÐ½Ð¸Ñ ÐºÑÐµÐ´Ð¸ÑÐ¾Ð² Ð¿Ð¾ ÑÐ»ÐµÐ´ÑÑÑÐ¸Ð¼
                                          Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÐ°Ð¼:
                                        </p>
                                      </div>
                                      {condition?.conditions?.map((openedOffer) => {
                                        return (
                                          <>
                                            <div
                                              className={styles.bank__info}
                                              style={{ background: '#fff', padding: 10, marginBottom: 20 }}
                                            >
                                              <div className={styles.bank__info_row}>
                                                <p className={styles.bank__info_title}>ÐÐ¾Ð¼ÐµÑ Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÐ°</p>
                                                <p className={styles.bank__info_sub} style={{ wordBreak: 'break-all' }}>
                                                  {openedOffer?.contractNumber}
                                                </p>
                                              </div>
                                              {item.bank.id != BANKS.EURAZ && (
                                                <div className={styles.bank__info_row}>
                                                  <p className={styles.bank__info_title}>ÐÐ¶ÐµÐ¼ÐµÑÑÑÐ½ÑÐ¹ Ð¿Ð»Ð°ÑÐµÐ¶, ÑÐµÐ½Ð³Ðµ:</p>
                                                  <p className={styles.bank__info_sub}>
                                                    {formatNumber(openedOffer?.monthlyInstalmentAmountKZ)}
                                                  </p>
                                                </div>
                                              )}

                                              {condition?.secondRateMonthlyPayment || item?.secondRateMonthlyPayment ? (
                                                <div className={styles.bank__info_row}>
                                                  <p className={styles.bank__info_title}>
                                                  ÐÐ¶ÐµÐ¼ÐµÑÑÑÐ½ÑÐ¹ Ð¿Ð»Ð°ÑÐµÐ¶ Ð²Ð¾ Ð²ÑÐ¾ÑÐ¾Ð¼ Ð¿ÐµÑÐ¸Ð¾Ð´Ðµ Ð¿Ð¾ Ð¾ÐºÐ¾Ð½ÑÐ°Ð½Ð¸Ñ Ð»ÑÐ³Ð¾ÑÐ½Ð¾Ð³Ð¾ Ð¿ÐµÑÐ¸Ð¾Ð´Ð°:
                                                  </p>
                                                  <p className={styles.bank__info_sub}>
                                                    {condition?.secondRateMonthlyPayment ||
                                                      item?.secondRateMonthlyPayment}
                                                  </p>
                                                </div>
                                              ) : null}
                                              {condition?.secondPayment || item?.secondPayment ? (
                                                <div className={styles.bank__info_row}>
                                                  <p className={styles.bank__info_title}>ÐÐ¶ÐµÐ¼ÐµÑÑÑÐ½ÑÐ¹ Ð¿Ð»Ð°ÑÐµÐ¶:</p>
                                                  <p className={styles.bank__info_sub}>
                                                    {condition?.secondPayment || item?.secondPayment}
                                                  </p>
                                                </div>
                                              ) : null}
                                              <div className={styles.bank__info_row}>
                                                <p className={styles.bank__info_title}>ÐÐ°Ð½Ðº:</p>
                                                <p className={styles.bank__info_sub}>{openedOffer?.finInstiut}</p>
                                              </div>
                                              <div className={styles.bank__info_row}>
                                                <p className={styles.bank__info_title}>ÐÑÑÐ°ÑÐ¾Ðº Ð¿Ð¾Ð³Ð°ÑÐµÐ½Ð¸Ñ, ÑÐµÐ½Ð³Ðµ:</p>
                                                <p className={styles.bank__info_sub}>
                                                  {formatNumber(openedOffer?.outstandingAmountKZ)}
                                                </p>
                                              </div>
                                              {isSapaConveyor(item?.bank?.id) &&
                                              (condition?.life_insurance_amount || item?.life_insurance_amount) ? (
                                                <div className={styles.bank__info_row}>
                                                  <p className={styles.bank__info_title}>Ð¡ÑÑÐ°ÑÐ¾Ð²Ð°Ð½Ð¸Ðµ Ð¶Ð¸Ð·Ð½Ð¸:</p>
                                                  <p className={styles.bank__info_sub}>
                                                    {condition?.life_insurance_amount || item?.life_insurance_amount}
                                                  </p>
                                                </div>
                                              ) : null}
                                            </div>
                                          </>
                                        );
                                      })}
                                    </>
                                  ) : null}

                                  <div
                                    style={{
                                      display: 'flex',
                                      justifyContent: 'flex-start',
                                      marginTop: 20,
                                    }}
                                  >
                                    {/* {item?.selected && deal?.paymentType?.id == PAYMENT_TYPES_CREDIT_CARD && (
                                        <Button
                                          text="ÐÐ¿Ð»Ð°ÑÐ¸ÑÑ ÐºÐ°ÑÑÐ¾Ð¹"
                                          fill
                                          onClick={() => cardPayment(item, condition)}
                                        />
                                      )}
                                      {item?.selected && deal?.paymentType?.id == PAYMENT_TYPES_CREDIT_INVOICE && (
                                        <Button text="ÐÐµÑÐµÐ¹ÑÐ¸ Ð² Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÑ" fill onClick={() => getInvoice(item)} />
                                      )} */}
                                    {
                                      <Button
                                        text="ÐÑÐ±ÑÐ°ÑÑ Ð¿ÑÐµÐ´Ð»Ð¾Ð¶ÐµÐ½Ð¸Ðµ"
                                        fill
                                        disabled={isExpired}
                                        onClick={() => chooseBank(item, condition?.offerType)}
                                      />
                                    }
                                  </div>
                                </div>
                              </>
                            );
                          })
                        ) : (
                          <>
                            <div className={styles.bank__info}>
                              <div className={styles.bank__info_row}>
                                <p className={styles.bank__info_title}>Ð¡ÑÐ¼Ð¼Ð° Ð·Ð°Ð¹Ð¼Ð°</p>
                                <p className={styles.bank__info_sub}>{formatNumber(item?.fullPrice)}</p>
                              </div>
                              <div className={styles.bank__info_row}>
                                <p className={styles.bank__info_title}>ÐÐµÑÐ²Ð¾Ð½Ð°ÑÐ°Ð»ÑÐ½ÑÐ¹ Ð²Ð·Ð½Ð¾Ñ, ÑÐµÐ½Ð³Ðµ</p>
                                <p className={styles.bank__info_sub}>{formatNumber(item?.initialFee)}</p>
                              </div>
                              <div className={styles.bank__info_row}>
                                <p className={styles.bank__info_title}>Ð¡ÑÐ¾Ðº ÐºÑÐµÐ´Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ñ:</p>
                                <p className={styles.bank__info_sub}>{item?.period} Ð¼.</p>
                              </div>
                              <div className={styles.bank__info_row}>
                                <p className={styles.bank__info_title}>ÐÑÐ¾ÑÐµÐ½ÑÐ½Ð°Ñ ÑÑÐ°Ð²ÐºÐ° (Ð³Ð¾Ð´Ð¾Ð²ÑÑ):</p>
                                <p className={styles.bank__info_sub}>{item?.percent}%</p>
                              </div>
                              {item.bank.id != BANKS.EURAZ && (
                                <div className={styles.bank__info_row}>
                                  <p className={styles.bank__info_title}>ÐÐ¶ÐµÐ¼ÐµÑÑÑÐ½ÑÐ¹ Ð¿Ð»Ð°ÑÐµÐ¶, ÑÐµÐ½Ð³Ðµ:</p>
                                  <p className={styles.bank__info_sub}>{formatNumber(item?.monthlyPayment)}</p>
                                </div>
                              )}
                            </div>
                            {isJetFin(item) ? (
                            <p style={{ color: '#7A6A55', fontSize: 13, marginTop: 10 }}>
                              Ð ÐµÑÐµÐ½Ð¸Ðµ Ð¿ÑÐµÐ´Ð²Ð°ÑÐ¸ÑÐµÐ»ÑÐ½Ð¾Ðµ: Ð±Ð°Ð½Ðº Ð¼Ð¾Ð¶ÐµÑ Ð¾ÑÐºÐ°Ð·Ð°ÑÑ Ð¸ Ð¿Ð¾ÑÐ»Ðµ Ð¾Ð´Ð¾Ð±ÑÐµÐ½Ð¸Ñ
                              ÑÐºÐ¾ÑÐ¸Ð½Ð³Ð° â Ð¿Ð¾ Ð¿ÑÐ¾Ð²ÐµÑÐºÐµ ÑÐ»ÑÐ¶Ð±Ñ Ð±ÐµÐ·Ð¾Ð¿Ð°ÑÐ½Ð¾ÑÑÐ¸ Ð¸Ð»Ð¸ ÑÐµÑÐµÐ½Ð¸Ñ ÐºÑÐµÐ´Ð¸ÑÐ½Ð¾Ð³Ð¾
                              ÐºÐ¾Ð¼Ð¸ÑÐµÑÐ°. ÐÐºÐ¾Ð½ÑÐ°ÑÐµÐ»ÑÐ½ÑÐ¼ ÑÑÐ¸ÑÐ°ÐµÑÑÑ Â«ÐÑÐµÐ´Ð¸Ñ Ð²ÑÐ´Ð°Ð½Â».
                            </p>
                          ) : null}
                          <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: 20 }}>
                              {/* {item?.selected && deal?.paymentType?.id == PAYMENT_TYPES_CREDIT_CARD && (
                                  <Button text="ÐÐ¿Ð»Ð°ÑÐ¸ÑÑ ÐºÐ°ÑÑÐ¾Ð¹" fill onClick={() => cardPayment(item)} />
                                )}
                                {item?.selected && deal?.paymentType?.id == PAYMENT_TYPES_CREDIT_INVOICE && (
                                  <Button text="ÐÐµÑÐµÐ¹ÑÐ¸ Ð² Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÑ" fill onClick={() => getInvoice(item)} />
                                )} */}
                              {
                              <Button
                                text="ÐÑÐ±ÑÐ°ÑÑ Ð¿ÑÐµÐ´Ð»Ð¾Ð¶ÐµÐ½Ð¸Ðµ"
                                fill
                                disabled={isExpired || awaitingMyCarRework(item, BANKS.MYCAR)}
                                onClick={() => chooseBank(item)}
                              />
                            }
                            </div>
                          </>
                        )}
                      </div>
                    </>
                  )}
                </div>
              );
            })}
        </div>
        <div style={{ marginBottom: 20, padding: '0 20px' }}>
          <Button onClick={printForClient} fill>
            Ð Ð°ÑÐ¿ÐµÑÐ°ÑÐ°ÑÑ Ð´Ð»Ñ ÐºÐ»Ð¸ÐµÐ½ÑÐ°
          </Button>
        </div>
      </div>

      {deal?.step === DEAL_STEPS.FINISH && (
        <CancelCreditFunding
          dealId={deal?.id}
          bankOwnerId={deal?.creditAppeal?.bankOwnerId}
          chunkId={deal?.chunkId}
          buttonText="ÐÑÐ¼ÐµÐ½Ð¸ÑÑ Ð·Ð°ÑÐ²ÐºÑ Ð¸ ÑÐ¸Ð½Ð°Ð½ÑÐ¸ÑÐ¾Ð²Ð°Ð½Ð¸Ðµ Eurasian bank"
        />
      )}

      {/* update, Ð° Ð½Ðµ onSubmit: onSubmit Ð·Ð´ÐµÑÑ â onBankSelect, Ð¸ Ð¾Ð½ ÑÑÑ Ð¶Ðµ
          Ð¿ÐµÑÐµÐºÐ¸Ð´ÑÐ²Ð°Ð» ÑÐ´ÐµÐ»ÐºÑ Ð½Ð° Ð¿ÐµÑÐ²ÑÐ¹ ÑÐ°Ð³ Ð±Ð°Ð½ÐºÐ°, Ð·Ð°ÑÐ¸ÑÐ°Ñ ÑÐ¾Ð»ÑÐºÐ¾ ÑÑÐ¾ Ð²ÑÐ±ÑÐ°Ð½Ð½ÑÐ¹
          Ð°Ð´Ð¼Ð¸Ð½Ð¾Ð¼ ÑÑÐ°Ð¿ (Ð² ÑÐ¾Ð¼ ÑÐ¸ÑÐ»Ðµ Ð½Ð¾Ð²ÑÐ¹ Â«Ð¢ÑÑÑÑÑÐ¾ÑÐ¾Ð½Ð½Ð¸Ð¹ Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÂ»). */}
      <DealConfigureSteps bankId={chosenBankId} dealId={deal?.id} update={update} />
      {succes.message && <Alert message={succes.message} onClick={setSucces} />}
    </>
  );
};

export default DealCredits;
